<template>
  <div :class="loading ? 'cursor-wait' : ''">

    <div v-if="modalChangePassword" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div v-if="errors.valid == false" class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                Cambiar Contraseña
              </h3>

              <div class="flex flex-col px-10 xl:px-0">

                <p class="py-4">
                  <input
                    v-model="user.current_password"
                    type="password"
                    placeholder="Contraseña Actual"
                    autofocus="autofocus"
                    :class="errors.current_password ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.current_password" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.current_password }}
                  </span>
                </p>

                <p class="py-4">
                  <input
                    v-model="user.password"
                    type="password"
                    placeholder="Nueva Contraseña"
                    autofocus="autofocus"
                    :class="errors.password ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.password" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.password }}
                  </span>
                </p>

                <p class="py-4">
                  <input
                    v-model="user.password_confirmation"
                    type="password"
                    placeholder="Repetir Contraseña"
                    autofocus="autofocus"
                    :class="errors.password_confirmation ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.password_confirmation" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.password_confirmation }}
                  </span>
                </p>
              
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="modalChangePassword = false"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>

          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button 
              @click="changePassword"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                </path>
              </svg>
              Aceptar
            </button>
          </span>

          <span class="pr-4">
            <div v-if="loading">
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#338BFF">
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)" stroke-width="2">
                            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"/>
                            </path>
                        </g>
                    </g>
                </svg>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div class="sm:px-6 lg:px-8">
      <div class="max-w-sm bg-white shadow-lg rounded-lg overflow-hidden my-4">
          <img class="w-full h-56 object-cover object-center" :src="require('../assets/images/user-happer.png')" alt="avatar">
          <div class="flex items-center px-1 py-3 bg-gray-900" v-if="profile">
              <h1 class="mx-3 text-white font-semibold text-lg" v-for="r in profile.user.roles">{{ r }}</h1>
          </div>
          <div class="py-4 px-6">
            <h1 class="text-2xl font-semibold text-gray-800" v-if="profile">{{ profile.user.person.name }}</h1>
            <div class="cursor-pointer flex items-center mt-4 text-blue-700" @click="modalChangePassword = true; cleanUsers(); cleanErrors();">
                <svg class="h-5 w-5 fill-current">
                    <path d="M17.308,7.564h-1.993c0-2.929-2.385-5.314-5.314-5.314S4.686,4.635,4.686,7.564H2.693c-0.244,0-0.443,0.2-0.443,0.443v9.3c0,0.243,0.199,0.442,0.443,0.442h14.615c0.243,0,0.442-0.199,0.442-0.442v-9.3C17.75,7.764,17.551,7.564,17.308,7.564 M10,3.136c2.442,0,4.43,1.986,4.43,4.428H5.571C5.571,5.122,7.558,3.136,10,3.136 M16.865,16.864H3.136V8.45h13.729V16.864z M10,10.664c-0.854,0-1.55,0.696-1.55,1.551c0,0.699,0.467,1.292,1.107,1.485v0.95c0,0.243,0.2,0.442,0.443,0.442s0.443-0.199,0.443-0.442V13.7c0.64-0.193,1.106-0.786,1.106-1.485C11.55,11.36,10.854,10.664,10,10.664 M10,12.878c-0.366,0-0.664-0.298-0.664-0.663c0-0.366,0.298-0.665,0.664-0.665c0.365,0,0.664,0.299,0.664,0.665C10.664,12.58,10.365,12.878,10,12.878"></path>
                </svg>
                <h1 class="px-2 text-sm">Cambiar Contraseña</h1>
            </div>
            <div class="flex items-center mt-4 text-gray-700">
                <svg class="h-5 w-5 fill-current">
                  <path d="M10,15.654c-0.417,0-0.754,0.338-0.754,0.754S9.583,17.162,10,17.162s0.754-0.338,0.754-0.754S10.417,15.654,10,15.654z M14.523,1.33H5.477c-0.833,0-1.508,0.675-1.508,1.508v14.324c0,0.833,0.675,1.508,1.508,1.508h9.047c0.833,0,1.508-0.675,1.508-1.508V2.838C16.031,2.005,15.356,1.33,14.523,1.33z M15.277,17.162c0,0.416-0.338,0.754-0.754,0.754H5.477c-0.417,0-0.754-0.338-0.754-0.754V2.838c0-0.417,0.337-0.754,0.754-0.754h9.047c0.416,0,0.754,0.337,0.754,0.754V17.162zM13.77,2.838H6.23c-0.417,0-0.754,0.337-0.754,0.754v10.555c0,0.416,0.337,0.754,0.754,0.754h7.539c0.416,0,0.754-0.338,0.754-0.754V3.592C14.523,3.175,14.186,2.838,13.77,2.838z M13.77,13.77c0,0.208-0.169,0.377-0.377,0.377H6.607c-0.208,0-0.377-0.169-0.377-0.377V3.969c0-0.208,0.169-0.377,0.377-0.377h6.785c0.208,0,0.377,0.169,0.377,0.377V13.77z"></path>
                </svg>
                <h1 class="px-2 text-sm" v-if="profile">{{ profile.user.person.tel }}</h1>
            </div>
            <div class="flex items-center mt-4 text-gray-700">
                <svg class="h-5 w-5 fill-current">
                  <path d="M16.999,4.975L16.999,4.975C16.999,4.975,16.999,4.975,16.999,4.975c-0.419-0.4-0.979-0.654-1.604-0.654H4.606c-0.584,0-1.104,0.236-1.514,0.593C3.076,4.928,3.05,4.925,3.037,4.943C3.034,4.945,3.035,4.95,3.032,4.953C2.574,5.379,2.276,5.975,2.276,6.649v6.702c0,1.285,1.045,2.329,2.33,2.329h10.79c1.285,0,2.328-1.044,2.328-2.329V6.649C17.724,5.989,17.441,5.399,16.999,4.975z M15.396,5.356c0.098,0,0.183,0.035,0.273,0.055l-5.668,4.735L4.382,5.401c0.075-0.014,0.145-0.045,0.224-0.045H15.396z M16.688,13.351c0,0.712-0.581,1.294-1.293,1.294H4.606c-0.714,0-1.294-0.582-1.294-1.294V6.649c0-0.235,0.081-0.445,0.192-0.636l6.162,5.205c0.096,0.081,0.215,0.122,0.334,0.122c0.118,0,0.235-0.041,0.333-0.12l6.189-5.171c0.099,0.181,0.168,0.38,0.168,0.6V13.351z"></path>
                </svg>
                <h1 class="px-2 text-sm" v-if="profile">{{ profile.user.email }}</h1>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify';

Vue.use(VueAlertify);

export default {
  data() {
    return {
      profile: null,
      loading: false,
      modalChangePassword: false,
      errors: {
        valid: true
      },
      user: {
        current_password: null,
        password: null,
        password_confirmation: null
      }
    }
  },

  mounted() {
    const profile = localStorage.getItem('user')
    this.profile = JSON.parse(profile)
  },

  methods: {
    async changePassword() {
      if (this.validateForm()){
        this.loading = true
        try {
          this.user.email = this.profile.user.email
          await this.$http.post('/auth/changePassword', this.user)
          this.modalChangePassword = false
          this.$alertify.success('Se realizó el cambio de password correctamente!')  
        } catch (error) {
          if (error.response.status == 406){
            this.errors.valid = false
            this.errors.current_password = "Password Inválida!"
          }
          this.$alertify.error('ERROR. No se ha podido realizar el cambio de password!')
        } finally {
          this.loading = false
        }
      }
    },
    cleanUsers() {
      this.user = {
        current_password: null,
        password: null,
        password_confirmation: null
      }
    },
    cleanErrors() {
      this.loading = false
      this.errors = {
        current_password: null,
        password: null,
        password_confirmation: null,
        valid: true,
      }
    },
    validateForm() {
      this.cleanErrors()
      let valid = true

      if (this.user.current_password == '' || this.user.current_password == null){
        this.errors.current_password = "Ingrese su password actual!"
        valid = false
      }

      if (this.user.password == '' || this.user.password == null){
        this.errors.password = "Ingrese una nueva password!"
        valid = false
      }

      if (this.user.password_confirmation == '' || this.user.password_confirmation == null){
        this.errors.password_confirmation = "Ingrese nuevamente su nueva password!"
        valid = false
      } else {
        if (this.user.password != this.user.password_confirmation){
          this.errors.password_confirmation = "La password no coincide!"
          valid = false
        }
      }

      this.errors.valid = valid
      return valid
    }
  }
}
</script>
